export const DateParse = (date: string): string => {
	const month = date.substring(0, 2);
	const year = date.substring(2, date.length);
	return `${year}-${month}-01`;
};
